export const handleChangeDataPageCategoryProducts = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_CATEGORY_PRODUCTS', name, value
});